import { FC, useMemo } from "react";

import { Add, Filter as FilterIcon } from "@livechat/design-system-icons";
import { ActionMenu, ActionMenuItem, Button, IActionMenuOption, Icon } from "@livechat/design-system-react-components";

import { Filter } from "constants/filters";
import { useBreakpoints } from "hooks/use-breakpoints";

import { IFilterConfig } from "./interfaces";

interface IProps {
  chosenFilters: string[];
  disabledFilters?: Filter[];
  isOpen: boolean;
  filters: Filter[];
  filterConfigs: { [key in Filter]?: IFilterConfig };
  onItemSelect(filterType: Filter): void;
  onClose(): void;
  onOpen(): void;
}

export const FiltersMenu: FC<IProps> = ({
  chosenFilters,
  disabledFilters,
  isOpen,
  filters,
  filterConfigs,
  onItemSelect,
  onClose,
  onOpen,
}) => {
  const { isMobile } = useBreakpoints();

  const items = useMemo<IActionMenuOption[]>(() => {
    return filters.map((filterName: Filter) => ({
      key: filterName,
      element: (
        <ActionMenuItem
          leftNode={filterConfigs[filterName]?.icon && <Icon size="small" source={filterConfigs[filterName]!.icon} />}
        >
          {filterConfigs[filterName]?.title}
        </ActionMenuItem>
      ),
      onClick: (): void => onItemSelect(filterName),
      disabled: disabledFilters ? disabledFilters.includes(filterName) : false,
    }));
  }, [filters, filterConfigs, disabledFilters, onItemSelect]);

  return (
    <ActionMenu
      placement="bottom-start"
      visible={isOpen}
      selectedOptions={chosenFilters}
      onClose={onClose}
      options={items}
      triggerRenderer={
        <Button kind="secondary" size="compact" icon={<Icon source={isMobile ? FilterIcon : Add} />} onClick={onOpen}>
          {!isMobile && "Add filter"}
        </Button>
      }
    />
  );
};
